import { QR_TYPE } from 'features/generator/generatorTypes'

import { TTranslationFunction } from '@/types'

export const parseSortValue = (
	value: string,
): { id: string; desc: boolean } | null => {
	if (!value) return null
	const desc = value.endsWith('-desc')
	const id = desc ? value.slice(0, -5) : value
	return { id, desc }
}

export const getSortValueFromState = (
	id: string | undefined,
	desc: boolean | undefined,
): string => {
	if (!id) return ''
	return desc ? `${id}-desc` : id
}

export const getQrTypeOptions = (t: TTranslationFunction) => [
	{
		label: t('public__qr_types_section__website_url'),
		value: QR_TYPE.Url,
	},
	{
		label: t('public__qr_types_section__vcard'),
		value: QR_TYPE.VCard,
	},
	{
		label: t('public__qr_types_section__pdf'),
		value: QR_TYPE.Pdf,
	},
	{
		label: t('public__qr_types_section__images'),
		value: QR_TYPE.Images,
	},
	{
		label: t('public__qr_types_section__social_media'),
		value: QR_TYPE.SocialMedia,
	},
	{
		label: t('public__qr_types_section__video'),
		value: QR_TYPE.Video,
	},
	{
		label: t('public__qr_types_section__simple_text'),
		value: QR_TYPE.PlainText,
	},
	{
		label: t('public__qr_types_section__business_page'),
		value: QR_TYPE.BusinessPage,
	},
	{
		label: t('public__qr_types_section__facebook'),
		value: QR_TYPE.Facebook,
	},
	{
		label: t('public__qr_types_section__wifi'),
		value: QR_TYPE.Wifi,
	},
	{
		label: t('public__qr_types_section__app'),
		value: QR_TYPE.App,
	},
	{
		label: t('public__qr_types_section__menu'),
		value: QR_TYPE.Menu,
	},
]

export const getStatusOptions = (t: TTranslationFunction) => [
	{ label: t('dashboard__qr_table__controls__status_active'), value: 'false' },
	{ label: t('dashboard__qr_table__controls__status_paused'), value: 'true' },
]

export const getSortOptions = (t: TTranslationFunction) => [
	{
		label: t('dashboard__qr_table__controls__sort_asc_name'),
		value: 'name',
		desc: false,
	},
	{
		label: t('dashboard__qr_table__controls__sort_desc_name'),
		value: 'name-desc',
		desc: true,
	},
	{
		label: t('dashboard__qr_table__controls__sort_asc_type'),
		value: 'type',
		desc: false,
	},
	{
		label: t('dashboard__qr_table__controls__sort_desc_type'),
		value: 'type-desc',
		desc: true,
	},
	{
		label: t('dashboard__qr_table__controls__sort_asc_scans'),
		value: 'scans-desc',
		desc: true,
	},
	{
		label: t('dashboard__qr_table__controls__sort_desc_scans'),
		value: 'scans',
		desc: false,
	},
	{
		label: t('dashboard__qr_table__controls__sort_asc_created'),
		value: 'created-desc',
		desc: true,
	},
	{
		label: t('dashboard__qr_table__controls__sort_desc_created'),
		value: 'created',
		desc: false,
	},
	{
		label: t('dashboard__qr_table__controls__sort_asc_edited'),
		value: 'edited-desc',
		desc: true,
	},
	{
		label: t('dashboard__qr_table__controls__sort_desc_edited'),
		value: 'edited',
		desc: false,
	},
	{
		label: t('dashboard__qr_table__controls__sort_asc_status'),
		value: 'disabled',
		desc: false,
	},
	{
		label: t('dashboard__qr_table__controls__sort_desc_status'),
		value: 'disabled-desc',
		desc: true,
	},
]
